const STRATEGY_ADD_SPOTS = "page::strategy::detail::add-priority-spots";
const STRATEGY_DELETE_SPOT = "page::strategy::detail::delete-priority-spot";
const STRATEGY_PRIORITY_ORDER = "page::strategy::detail::change-priority-order";
const STRATEGY_RESET_REDIRECT = "page::strategy::detail::redirect::reset";
const UPDATE_STRATEGY = "page::strategy::detail::update-strategy";

function updateUiStrategyAction(payload) {
  return {
    payload,
    type: UPDATE_STRATEGY,
  };
}

function changePriorityOrderAction(payload) {
  return {
    payload,
    type: STRATEGY_PRIORITY_ORDER,
  };
}

function deleteSpotAction(payload) {
  return {
    payload,
    type: STRATEGY_DELETE_SPOT,
  };
}

function addSpotsAction(payload) {
  return {
    payload,
    type: STRATEGY_ADD_SPOTS,
  };
}

const resetUiRedirectAction = {
  type: STRATEGY_RESET_REDIRECT,
};

export {
  addSpotsAction,
  changePriorityOrderAction,
  deleteSpotAction,
  resetUiRedirectAction,
  STRATEGY_ADD_SPOTS,
  STRATEGY_DELETE_SPOT,
  STRATEGY_PRIORITY_ORDER,
  STRATEGY_RESET_REDIRECT,
  UPDATE_STRATEGY,
  updateUiStrategyAction,
};
